__turbopack_context__.v({
  "category-skeleton-column": "trending-skills-module-scss-module__XZQA-G__category-skeleton-column",
  "category-skeleton-fill": "trending-skills-module-scss-module__XZQA-G__category-skeleton-fill",
  "column": "trending-skills-module-scss-module__XZQA-G__column",
  "container": "trending-skills-module-scss-module__XZQA-G__container",
  "content": "trending-skills-module-scss-module__XZQA-G__content",
  "content-japan-variant": "trending-skills-module-scss-module__XZQA-G__content-japan-variant",
  "heading-row": "trending-skills-module-scss-module__XZQA-G__heading-row",
  "japan-variant": "trending-skills-module-scss-module__XZQA-G__japan-variant",
  "section-cta": "trending-skills-module-scss-module__XZQA-G__section-cta",
  "section-cta-skeleton": "trending-skills-module-scss-module__XZQA-G__section-cta-skeleton",
  "stat-darker": "trending-skills-module-scss-module__XZQA-G__stat-darker",
  "top-skill": "trending-skills-module-scss-module__XZQA-G__top-skill",
  "top-skill-cta": "trending-skills-module-scss-module__XZQA-G__top-skill-cta",
  "top-skill-skeleton": "trending-skills-module-scss-module__XZQA-G__top-skill-skeleton",
  "top-skill-stat": "trending-skills-module-scss-module__XZQA-G__top-skill-stat",
  "top-skill-with-cta": "trending-skills-module-scss-module__XZQA-G__top-skill-with-cta",
  "top-skill-with-cta-japan-variant": "trending-skills-module-scss-module__XZQA-G__top-skill-with-cta-japan-variant",
  "topic": "trending-skills-module-scss-module__XZQA-G__topic",
  "topic-learners": "trending-skills-module-scss-module__XZQA-G__topic-learners",
  "trending-skills": "trending-skills-module-scss-module__XZQA-G__trending-skills",
  "wrapped-trending-topics": "trending-skills-module-scss-module__XZQA-G__wrapped-trending-topics",
});
